export default __webpack_public_path__ + "static/media/ic-event-transfer.b6a69091.svg";